import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';

/**
 * render img present in S3: brandclub/media_asset
 */
var AppImage = function (_a) {
    var src = _a.src, _b = _a.isRawSrc, isRawSrc = _b === void 0 ? false : _b, alt = _a.alt, rest = __rest(_a, ["src", "isRawSrc", "alt"]);
    return React.createElement("img", __assign({ src: isRawSrc ? src : src, alt: alt }, rest));
};

export { AppImage };
//# sourceMappingURL=index.js.map
